<script setup lang="ts">
import type { OfferCreator } from "@/shared/types";
const { t } = useI18n();
const dayjs = useDayjs();
const props = withDefaults(defineProps<{ offerCreator?: OfferCreator }>(), {
  offerCreator: () => ({
    id: 0,
    nickname: "Unknown order creator",
    completedOrders: 0,
    cancelledOrders: 0,
    averagePaymentTime: 0,
  }),
});
const allOrders = computed(
  () => props.offerCreator.completedOrders + props.offerCreator.cancelledOrders
);
const localePath = useLocalePath();
</script>

<template>
  <h2 class="mt-0">
    <NuxtLink
      v-if="props.offerCreator.nickname"
      :to="localePath(`/profile/${props.offerCreator.id}`)"
    >
      {{ props.offerCreator.nickname }}</NuxtLink
    >
    <span v-else>{{ t("c-offers-traderInfo-unknownCreator") }}</span>
    <el-tooltip
      class="box-item"
      effect="dark"
      :content="
        props.offerCreator.isOnline
          ? t('c-offers-traderInfo-online')
          : `${t('c-offers-traderInfo-wasOnline')} ${dayjs(
              props.offerCreator.lastOnlineDate
            ).fromNow()}`
      "
      placement="top-start"
    >
      <el-badge
        class="ml-1"
        :type="props.offerCreator.isOnline ? 'success' : 'info'"
        is-dot
      ></el-badge>
    </el-tooltip>
  </h2>
  <p>
    {{ t("c-offers-traderInfo-orders") }}:
    <b>
      {{ allOrders || t("c-offers-traderInfo-noOrders") }}
    </b>
    <template v-if="allOrders">
      -
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="t('c-offers-traderInfo-completionRate')"
        placement="bottom-start"
      >
        <span class="color-success">
          {{
            (
              100 -
              (props.offerCreator.cancelledOrders /
                (props.offerCreator.completedOrders || 1)) *
                100
            ).toFixed(2)
          }}
          %
        </span>
      </el-tooltip>
    </template>
  </p>
</template>

<style lang="scss" scoped>
.color-success {
  color: var(--el-color-success) !important;
}
.color-warning {
  color: var(--el-color-warning) !important;
}
</style>
